import { Component, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Presentacion } from '../../../../interfaces/presentacion.interface';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-presentacion',
    templateUrl: './presentacion.component.html',
    styleUrls: ['./presentacion.component.css'],
})
export class PresentacionComponent {
    presentaciones: Presentacion[];
    busquedaPre = '';

    product: any;
    currentProduct = {
        id: null,
        nombreComercial: '',
        presentaciones: [],
        numeroRegistroIca: undefined,
        casaProductora: undefined,
        tipoProductoId: null,
    };

    @ViewChild('modalPresentaciones') modalPresentaciones: ElementRef;

    currentPresentacion: any;

    quantity: number = null;
    private productId: string;
    private apiUrl: string = environment.apiSiriUrl;
    tipoProductoID: null;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private http: HttpClient,
        private translate: TranslateService
    ) {
        this.translate.setDefaultLang('es');
        this.translate.use('es');
    }

    ngOnInit() {
        this.route.paramMap.subscribe((params) => {
            this.productId = params.get('id-producto');
            const navigation = window.history.state;
            if (navigation.currentProduct) {
                this.currentProduct = navigation.currentProduct;
                this.tipoProductoID = this.currentProduct.tipoProductoId;
                this.presentaciones = this.currentProduct.presentaciones;
            } else {
                this.loadPresentation();
            }
        });
    }

    loadPresentation() {
        this.http
            .get<any[]>(`${this.apiUrl}producto/` + this.productId)
            .subscribe(
                (response) => {
                    this.product = response;
                    this.presentaciones = this.product.presentaciones;
                    this.currentProduct = this.product;
                },
                (error) => {
                    console.error('Error al cargar presentacion', error);
                }
            );
    }

    editarPresentacion(presentacion: any) {
        this.currentPresentacion = presentacion;
        this.quantity = presentacion.cantidad;
        this.router.navigate(
            [`${this.productId}/presentaciones/${presentacion.id}`],
            {
                state: {
                    currentPresentation: this.currentPresentacion,
                    currentProduct: this.currentProduct,
                },
            }
        );
    }

    mostrarTexto() {
        this.translate
            .get('presentaciones.alertaAyuda')
            .subscribe((translatedText: string) => {
                Swal.fire('', translatedText, 'info');
            });
    }

    activarPresentacion(presentacion) {
        const formData = {
            empaqueUnidadMedidaId: presentacion.empaqueUnidadMedidaId,
            productoId: presentacion.productoId,
            cantidad: presentacion.cantidad,
            estado: !presentacion.estado,
        };

        this.http
            .put(`${this.apiUrl}presentacion/${presentacion.id}`, formData)
            .subscribe(
                (response) => {
                    this.loadPresentation();
                },
                (error) => {
                    console.error('Error updating the presentation', error);
                }
            );
    }

    addPresentation() {
        this.router.navigate([`${this.productId}/presentaciones/agregar`], {
            state: {
                currentPresentation: this.currentPresentacion,
                currentProduct: this.currentProduct,
            },
        });
    }
}
